import React, { useState } from "react";
import "./FormAS.css";
import LoaderVWC from "../../components/LoaderVWC";
import PersonIcon from "@mui/icons-material/Person";
import TaskIcon from "@mui/icons-material/Task";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import {
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Divider,
} from "@mui/material";
import Error from "../../components/Error";
import { Trans, useTranslation } from "react-i18next";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import StoreIcon from "@mui/icons-material/Store";
import leisureIcon from "../../img/icons/leisure.svg";

const FormAS = ({
  inputData,
  setInputData,
  startRun,
  runLoading,
  runError,
}) => {
  const [isSummaryView, setIsSummaryView] = useState(false);
  const [hideError, setHideError] = useState(false);
  const { t, i18n } = useTranslation();

  function handleResetForm() {
    setHideError(true);
    setIsSummaryView(false);
  }

  function startRunHandler() {
    setHideError(false);
    startRun();
  }

  return (
    <div className="nc-form">
      <div className="nc-form-input">
        <div className="flex align-items-center">

          <img
            src={leisureIcon}
            alt="Leisure Icon"
            style={{ width: "32px", height: "32px" }}
          />
          <span className="nc-form-title">{t("module.Abonnement sportschool")}</span>
        </div>
        <span className="nc-form-subtitle">
          {isSummaryView ? (
            <span>{t("controleerJeGegevensText")}</span>
          ) : (
            <span>{t("fillOutYourDetails")}</span>
          )}
        </span>
        <Divider sx={{ width: "100%", marginBottom: "24px" }} />
        <div className="nc-form-main">
          {!isSummaryView && (
            <React.Fragment>
              <div className="nc-inputs">
                <span className="nc-inputs-title">
                  <PersonIcon sx={{ color: "#439BD9" }} />
                  {t("persoonlijkeGegevens")}
                </span>
                <div className="nc-textfields">
                  <TextField
                    label={t("naam")}
                    variant="outlined"
                    value={inputData?.name || ""}
                    onChange={(e) =>
                      setInputData({ ...inputData, name: e.target.value })
                    }
                    required
                    sx={{
                      backgroundColor: "#F9FCFE",
                      border: "1px solid #ECF5FD",
                    }}
                  />
                  <TextField
                    label="Email"
                    email
                    variant="outlined"
                    value={inputData?.email || ""}
                    onChange={(e) =>
                      setInputData({ ...inputData, email: e.target.value })
                    }
                    required
                    sx={{
                      backgroundColor: "#F9FCFE",
                      border: "1px solid #ECF5FD",
                    }}
                  />
                </div>
                <span
                  className="nc-inputs-title"
                  style={{ marginBottom: "-16px", marginTop: "24px" }}
                >
                  <StoreIcon sx={{ color: "#439BD9" }} />
                  {t("typeVerkoop")}
                </span>

                <span
                  className="nc-inputs-title"
                  style={{ marginBottom: "-16px" }}
                >
                  <DirectionsCarIcon sx={{ color: "#439BD9" }} />
                  {t("Kenteken")}
                </span>
              </div>

              <div className="disclaimer-container">
                <div className="disclaimer-content">
                  <span
                    className="nc-inputs-title"
                    style={{ marginBottom: "-16px" }}
                  >
                    Disclaimer
                  </span>

                  <p style={{ fontFamily: "Lato" }}>
                    {t("testDisclaimerLong")}
                    <br />
                    <br />
                    {t("testDisclaimerLong2")}
                  </p>
                  <span className="nc-inputs-title">{t("toestemming")}</span>
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{
                          color: "#439BD9",
                          justifyContent: "start",
                        }}
                      />
                    }
                    label={
                      i18n.language === "nl" ? (
                        <Trans
                          i18nKey="avwAkkoord"
                          components={{
                            avw: (
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://voorwaardenchecker.nl/nl/algemene-voorwaarden"
                              >
                                Algemene Voorwaarden
                              </a>
                            ),
                            privacyverklaring: (
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://voorwaardenchecker.nl/nl/privacyverklaring"
                              >
                                Privacyverklaring
                              </a>
                            ),
                          }}
                        />
                      ) : (
                        <Trans
                          i18nKey="avwAkkoord"
                          components={{
                            avw: (
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://checkyourterms.com/en/terms-and-conditions"
                              >
                                Terms and Conditions
                              </a>
                            ),
                            privacyverklaring: (
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://checkyourterms.com/en/privacy-statement"
                              >
                                Privacy statement
                              </a>
                            ),
                          }}
                        />
                      )
                    }
                    checked={inputData?.agreedGtc}
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        agreedGtc: e.target.checked,
                      })
                    }
                    sx={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "start",
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px", // of een andere gewenste grootte
                        fontWeight: 400,
                        lineHeight: "180%",
                      },
                    }}
                  />
                  {/* <FormControlLabel
                      control={<Checkbox />}
                      label={t("disclaimerGelezen")}
                      checked={inputData?.agreedDisclaimer}
                      onChange={(e) =>
                        setInputData({
                          ...inputData,
                          agreedDisclaimer: e.target.checked,
                        })
                      }
                    /> */}
                  <div className="proceed-btn">
                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{
                        color: "#fff",
                        borderRadius: "40px",
                        textTransform: "none",
                      }}
                      onClick={() => setIsSummaryView(true)}
                      disabled={
                        inputData?.agreed === false ||
                        inputData?.disclaimerAgreed === false ||
                        inputData?.licensePlate === "" ||
                        inputData?.licensePlate.length !== 6 ||
                        inputData?.agreedGtc === false
                      }
                    >
                      {t("bevestigen")}
                    </Button>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          {isSummaryView && (
            <React.Fragment>
              <div className="nc-summary">
                <span className="nc-inputs-title mb-1">
                  <TaskIcon sx={{ color: "#439BD9" }} />
                  {t("samenvatting")}
                </span>
                <div className="nc-summary">
                  <div className="nc-summary-row">
                    <label>{t("naam")}</label>
                    <span>{`${inputData?.name || ""}`}</span>
                  </div>
                  <div className="nc-summary-row">
                    <label>E-mail</label>
                    <span>{inputData?.email || ""}</span>
                  </div>
                  <div className="nc-summary-row">
                    <label>{t("taal")}</label>
                    <span>{inputData?.language || ""}</span>
                  </div>
                  {/* <div className="nc-summary-row">
                    <label>{t("heeftDoorgehaaldeTekst")}</label>
                    <span>
                      {inputData?.hasStrikethrough ? t("ja") : t("nee")}
                    </span>
                  </div> */}
                  <div className="nc-summary-row">
                    <label>{t("occasionType")}</label>
                    <span>{inputData.purchaseType}</span>
                  </div>
                  <div className="nc-summary-row">
                    <label>{t("Kenteken")}</label>
                    <span>{inputData?.licensePlate || ""}</span>
                  </div>
                  {/* <div className="nc-summary-row">
                    <label>Algemene voorwaarden huurcontract</label>
                    <span>
                      {inputData.contractFile
                        ? inputData?.termsFile?.name
                        : "(Geen)"}
                    </span>
                  </div> */}
                </div>
              </div>
              <div className="nc-summary-confirm">
                <div className="disclaimer-content">
                  {runLoading ? (
                    <div className="run-loading">
                      <LoaderVWC inline message={t("checkInUitvoering")} />
                    </div>
                  ) : runError && hideError === false ? (
                    <React.Fragment>
                      <Error statusCode={runError.status} detail={runError} />
                      <Button
                        variant="contained"
                        sx={{
                          color: "#439BD9",
                          backgroundColor: "#D7E9F7",
                          borderRadius: "40px",
                          textTransform: "none",
                          width: "100px",
                        }}
                        onClick={handleResetForm}
                      >
                        {t("terug")}
                      </Button>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span className="nc-inputs-title">
                        <DomainVerificationIcon sx={{ color: "#439BD9" }} />
                        {t("checkStarten")}
                      </span>
                      <p style={{ fontFamily: "Lato" }}>
                        {t("allesIngevuldVraag")}
                      </p>
                      <div className="start-check-btns">
                        <Button
                          variant="contained"
                          sx={{
                            color: "#439BD9",
                            backgroundColor: "#D7E9F7",
                            borderRadius: "40px",
                            textTransform: "none",
                          }}
                          onClick={() => setIsSummaryView(false)}
                        >
                          {t("terug")}
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          sx={{
                            color: "#fff",
                            borderRadius: "40px",
                            textTransform: "none",
                          }}
                          onClick={startRunHandler}
                        >
                          {t("starten")}
                        </Button>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormAS;
